import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { UserService } from '../../core/services/user/user.service';

@Component({
    selector: 'app-login',
    imports: [FormsModule],
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  username: string = '';
  password: string = '';
  errorMessage: string = '';

  constructor(private router: Router, private userService: UserService) {}

  login() {
    // TODO: reemplazar por llamada real al API de autenticación.
    // El token JWT que devuelva el backend debe pasarse a loginWithToken().
    //
    // Ejemplo:
    //   this.authService.login(this.username, this.password).subscribe(response => {
    //     localStorage.setItem('isLoggedIn', 'true');
    //     this.userService.loginWithToken(response.JWTToken);
    //     this.router.navigate(['/home']);
    //   });

    if (this.username === 'test' && this.password === 'test') {
      localStorage.setItem('isLoggedIn', 'true');
      this.router.navigate(['/home']);
    } else {
      this.errorMessage = 'Credenciales incorrectas';
    }
  }
}
